import axios from 'axios';
import { API_URL } from './baseUrl';

// 医生提交患者资料的请求函数
export const ReferalPatient = async (Data) => {
    try {
        const response = await axios.post(`${API_URL}/ReferalPatient`, Data);
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};



// 医生上传文件的请求函数
export const UploadFiles = async (Data) => {
    try {
        const response = await axios.post(`${API_URL}/upload`, Data, {
            headers: {
                "Content-Type": "multipart/form-data", // 确保请求头正确
            },
        });
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};


// 患者上传文件的请求函数
export const PatientUploadFiles = async (Data) => {
    try {
        const response = await axios.post(`${API_URL}/patientupload`, Data, {
            headers: {
                "Content-Type": "multipart/form-data", // 确保请求头正确
            },
        });
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};


// 患者提交资料的请求函数
export const PatientReferalPatient = async (Data) => {
    try {
        const response = await axios.post(`${API_URL}/PatientReferalPatient`, Data);
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};
